<template>
  <v-app>
    <v-main fluid fill-height>
      <slot />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "PrintLayout",
  data: () => ({}),
};
</script>
